// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MPUj","footer":"styles_footer__2AC7l","passCodeTooltip":"styles_passCodeTooltip__2QdK8"};